import { useState } from 'react';
import { SignInButton } from '@authifi/clique-react-ui/auth';
import { SdkDocsPanel } from '../components/SdkDocsPanel';

type SignInTab = 'sign-in' | 'sdk';

export function SignInPage() {
  const [activeTab, setActiveTab] = useState<SignInTab>('sign-in');

  return (
    <div className="min-h-screen flex flex-col bg-[var(--clique-bg-subtle)]">
      <div
        className="flex items-center gap-1 px-6 bg-[var(--clique-bg)] border-b border-[var(--clique-border)]"
        role="tablist"
        aria-label="Page view"
      >
        <TabButton
          label="Sign in"
          icon="pi pi-sign-in"
          active={activeTab === 'sign-in'}
          onClick={() => setActiveTab('sign-in')}
        />
        <TabButton
          label="Integration help"
          icon="pi pi-code"
          active={activeTab === 'sdk'}
          onClick={() => setActiveTab('sdk')}
        />
      </div>

      {activeTab === 'sign-in' ? (
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="text-center max-w-sm">
            <h1 className="text-3xl font-bold mb-2 text-[var(--clique-fg)]">Clique</h1>
            <p className="mb-8 text-[var(--clique-fg-secondary)]">Auth Management Console</p>
            <SignInButton label="Sign in with LabShare Auth" className="w-full" />
          </div>
        </div>
      ) : (
        <div className="flex-1 overflow-auto p-6">
          <SdkDocsPanel docKey="signin" />
        </div>
      )}
    </div>
  );
}

function TabButton({
  label,
  icon,
  active,
  onClick,
}: {
  label: string;
  icon: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={
        active
          ? 'inline-flex items-center gap-2 px-4 py-3 text-sm cursor-pointer text-[var(--clique-primary)] font-semibold border-b-2 border-[var(--clique-primary)]'
          : 'inline-flex items-center gap-2 px-4 py-3 text-sm cursor-pointer text-[var(--clique-fg-secondary)] border-b-2 border-transparent'
      }
    >
      <i aria-hidden="true" className={icon} />
      {label}
    </button>
  );
}
